import { render, staticRenderFns } from "./SuggestionApp.vue?vue&type=template&id=0e345065&scoped=true"
import script from "./SuggestionApp.vue?vue&type=script&lang=js"
export * from "./SuggestionApp.vue?vue&type=script&lang=js"
import style0 from "./SuggestionApp.vue?vue&type=style&index=0&id=0e345065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e345065",
  null
  
)

export default component.exports